// /client/src/components/AdminDashboard/Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './AdminDashboard.css';

// Only disable console.logs in production
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.error = () => {};
}

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/api'; // Fallback for local dev
      console.log('API URL in production:', apiUrl);
      console.log('Making POST request to:', `${apiUrl}/admin/login`);
      console.log('Request body:', { email, password });
      const response = await axios.post(`${apiUrl}/admin/login`, {
        email,
        password,
      });

      const { token } = response.data;
      localStorage.setItem('adminToken', token);
      navigate('/admin28976730');
      console.log('Admin login successful');
    } catch (error) {
      const errorMsg = error.response?.data?.error || 'Something went wrong. Please try again.';
      setErrorMessage(errorMsg);
      console.error('Admin login error:', error);
    }
  };

  return (
    <div className="login-container">
      <header className="admin-dashboard-header text-center mb-4">
        <div className="admin-dashboard-logo"></div>
        <h2 style={{ color: 'white', fontWeight: '10', marginTop: '10px' }}>Admin Login</h2>
      </header>
      <form onSubmit={handleSubmit}>
        <div>
          <h6>Email:</h6>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <h6>Password:</h6>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
        <button type="submit">Login</button>
      </form>
    </div>
  );
};

export default Login;